import React, { FC, useEffect, useRef, useState } from 'react';
import { api } from '../../careand-redux/api/ApiThunks';
import { TotalUnreadCountWithLinked } from '../../careand-redux/selectors';
import { useIsLoading } from '../../careand-redux/slices/ui/hooks';
import { useAppSelector } from '../../careand-redux/store';
import { useAppDispatch } from '../../careand-redux/useAppDispatch';
import { Device } from '../../services/Native/Device';
import { UserRoleEnum } from '../../generated/api';

// TODO verify if chats decrease value
const UnreadCountListener: FC<{ userId: string | undefined; role: UserRoleEnum | undefined }> = ({
  userId,
  role,
}) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const prevIsLoadingRef = useRef(isLoading);

  const loadingChat = useIsLoading(api.Chat.updateChatLastRead);
  const loadingMarkRead = useIsLoading(api.HealthRecords.markHealthRecordRead);
  const combinedLoading = loadingChat || loadingMarkRead;

  const unread = useAppSelector(TotalUnreadCountWithLinked);

  useEffect(() => {
    setIsLoading(!!combinedLoading);
  }, [combinedLoading]);

  // When a read persists (chat last-read marker or health-record read) finishes, refetch the
  // authoritative unread total — the BE owns the count now, so we pull it rather than computing it
  // client-side. Runs on every platform so the web badge stays fresh too; native sync is handled by
  // the sendUnreadCountUpdate effect below.
  useEffect(() => {
    if (!userId || role !== 'patient') {
      return;
    }
    if (prevIsLoadingRef.current && !isLoading) {
      dispatch(api.HealthRecords.countUnreadHealthRecords({ patientId: userId }));
    }
    prevIsLoadingRef.current = isLoading;
  }, [dispatch, userId, isLoading]);

  useEffect(() => {
    if (role !== 'patient') {
      return;
    }
    Device.sendUnreadCountUpdate(unread);
  }, [unread]);

  return null;
};

export default UnreadCountListener;
